// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { LecturePage } from '../models';
import { LecturePageCreate } from '../models';
import { LecturePageEdit } from '../models';
import { Sort } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * LecturePageApi - axios parameter creator
 * @export
 */
export const LecturePageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, page_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/lecture/{id}/page/{page_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture page.
         * @param {string} id 
         * @param {LecturePageCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LecturePageCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling create.');
            }
            const localVarPath = `/v1/lecture/{id}/page/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {LecturePageEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, page_id: string, body?: LecturePageEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/lecture/{id}/page/{page_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, page_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/lecture/{id}/page/{page_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"page_id"}}`, encodeURIComponent(String(page_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture pages.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sort.');
            }
            const localVarPath = `/v1/lecture/{id}/page/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LecturePageApi - functional programming interface
 * @export
 */
export const LecturePageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, page_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LecturePageApiAxiosParamCreator(configuration)._delete(id, page_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture page.
         * @param {string} id 
         * @param {LecturePageCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LecturePageCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LecturePage> {
            const localVarAxiosArgs = LecturePageApiAxiosParamCreator(configuration).create(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {LecturePageEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, page_id: string, body?: LecturePageEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LecturePage> {
            const localVarAxiosArgs = LecturePageApiAxiosParamCreator(configuration).edit(id, page_id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, page_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LecturePage> {
            const localVarAxiosArgs = LecturePageApiAxiosParamCreator(configuration).get(id, page_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture pages.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LecturePageApiAxiosParamCreator(configuration).sort(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LecturePageApi - factory interface
 * @export
 */
export const LecturePageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, page_id: string, options?: any) {
            return LecturePageApiFp(configuration)._delete(id, page_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture page.
         * @param {string} id 
         * @param {LecturePageCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LecturePageCreate, options?: any) {
            return LecturePageApiFp(configuration).create(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {LecturePageEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, page_id: string, body?: LecturePageEdit, options?: any) {
            return LecturePageApiFp(configuration).edit(id, page_id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture page.
         * @param {string} id 
         * @param {string} page_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, page_id: string, options?: any) {
            return LecturePageApiFp(configuration).get(id, page_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture pages.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any) {
            return LecturePageApiFp(configuration).sort(id, body, options)(axios, basePath);
        },
    };
};

/**
 * LecturePageApi - object-oriented interface
 * @export
 * @class LecturePageApi
 * @extends {BaseAPI}
 */
export class LecturePageApi extends BaseAPI {
    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Delete lecture page.
     * @param {string} id 
     * @param {string} page_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LecturePageApi
     */
    public _delete(id: string, page_id: string, options?: any) {
        return LecturePageApiFp(this.configuration)._delete(id, page_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Create new lecture page.
     * @param {string} id 
     * @param {LecturePageCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LecturePageApi
     */
    public create(id: string, body?: LecturePageCreate, options?: any) {
        return LecturePageApiFp(this.configuration).create(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Edit lecture page.
     * @param {string} id 
     * @param {string} page_id 
     * @param {LecturePageEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LecturePageApi
     */
    public edit(id: string, page_id: string, body?: LecturePageEdit, options?: any) {
        return LecturePageApiFp(this.configuration).edit(id, page_id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
     * @summary Get lecture page.
     * @param {string} id 
     * @param {string} page_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LecturePageApi
     */
    public get(id: string, page_id: string, options?: any) {
        return LecturePageApiFp(this.configuration).get(id, page_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Sort lecture pages.
     * @param {string} id 
     * @param {Array<Sort>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LecturePageApi
     */
    public sort(id: string, body?: Array<Sort>, options?: any) {
        return LecturePageApiFp(this.configuration).sort(id, body, options)(this.axios, this.basePath);
    }

}
